module.exports = __webpack_public_path__ + "static/media/bn.ea3111ae.svg";